import React, { useEffect, useState } from 'react';
import { Modal, Backdrop, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import styles from './ConfirmationModal.module.scss';
import { usePaymentBooking } from '../../hooks/usePaymentBooking';
import PaymentIframeModal from '../ui/PaymentIframeModal/PaymentIframeModal';
import { localStorageHelper } from '../../utils/localStorageHelper';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  bookingUid: string;
}

export const ConfirmationModal = ({ open, onClose, bookingUid }: ConfirmationModalProps) => {
  const { t } = useTranslation();
  const {
    initiatePayment,
    loading: paymentLoading,
    error: paymentError,
    paymentUrl,
    clearPaymentUrl
  } = usePaymentBooking();

  const [professionalName, setProfessionalName] = useState<string>('el profesional');
  const [showToast, setShowToast] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (open) {
      setShowToast(true);
      setShowMessage(true);
      const stored = localStorageHelper.getItem<any>('bookingDetails');
      if (stored && stored.professionalName) {
        setProfessionalName(stored.professionalName);
      }
    } else {
      setShowToast(false);
      setShowMessage(false);
    }
  }, [open]);

  useEffect(() => {
    if (!showMessage) return;
    const timer = setTimeout(() => setShowMessage(false), 6000);
    return () => clearTimeout(timer);
  }, [showMessage]);

  const handlePayNowClick = () => {
    initiatePayment(bookingUid);
  };

  const handleClosePaymentModal = () => {
    clearPaymentUrl();
    onClose();
  };

  return (
    <>
      <Modal
        open={open && !paymentUrl}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          className: styles['confirmation-modal__backdrop'],
        }}
      >
        <div className={styles['confirmation-modal__content']}>
          <article className="bw-modal-card bw-modal-card--center bw-modal-card--confirmation" role="dialog" aria-modal="true" aria-labelledby="pending-title">
            <div className="bw-status-icon" aria-hidden="true">
              <svg viewBox="0 0 80 80" fill="none">
                <circle cx="40" cy="40" r="40" fill="#C2D9CA"/>
                <circle cx="40" cy="40" r="32" fill="#D6E5DC"/>
                <path
                  d="M28 40.5L36 49L53 32"
                  stroke="#4A7C5F"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span className="bw-modal-eyebrow">
              {t('landing.ConfirmationModal.eyebrow')}
            </span>
            <h2 id="pending-title" className="bw-modal-title">
              {t('landing.ConfirmationModal.title')}
            </h2>
            <p className="bw-modal-copy">
              {t('landing.ConfirmationModal.subtitle')}
            </p>

            <div className="bw-modal-actions">
              <button
                className="bw-btn bw-btn-primary bw-btn-full"
                onClick={handlePayNowClick}
                disabled={paymentLoading}
              >
                {paymentLoading ? <CircularProgress size={24} color="inherit" /> : t('landing.ConfirmationModal.payNow')}
              </button>

              <button
                className="bw-btn bw-btn-secondary bw-btn-full"
                onClick={onClose}
              >
                {t('landing.ConfirmationModal.keepExploring')}
              </button>
            </div>

            {paymentError && (
              <p className="bw-modal-copy" style={{ color: 'var(--bw-semantic-error, #D95C5C)' }}>{paymentError}</p>
            )}
          </article>
        </div>
      </Modal>
{/* 
      {open && !paymentUrl && (
        <div className="bw-toast" role="status">
          <span className="bw-toast__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"></path></svg>
          </span>
          <div className="bw-toast__content">
            <strong className="bw-toast__title">{t('landing.ConfirmationModal.toastTitle')}</strong>
            <span className="bw-toast__message">
              {t('landing.ConfirmationModal.toastMessage', { professional: professionalName })}
            </span>
          </div>
          <button className="bw-toast__close" type="button" aria-label={t('landing.ConfirmationModal.closeAria', 'Cerrar')} onClick={() => setShowToast(false)}>
            ×
          </button>
        </div>
      )} */}

      {showMessage && (
        <div className="bw-message" role="status">
          <span className="bw-message__icon" aria-hidden>
            ✓
          </span>
          <div className="bw-message__content">
            <strong className="bw-message__title">{t('landing.ConfirmationModal.toastTitle')}</strong>
            <div className="bw-message__message">{t('landing.ConfirmationModal.toastMessage', { professional: professionalName })}</div>
          </div>
          <button className="bw-message__close" onClick={() => setShowMessage(false)} aria-label={t('landing.ConfirmationModal.closeMessageAria', 'Cerrar mensaje')}>×</button>
        </div>
      )}

      <PaymentIframeModal
        open={!!paymentUrl}
        onClose={handleClosePaymentModal}
        url={paymentUrl}
      />
    </>
  );
};
